/* eslint-disable */
import React, { useState } from 'react';
import Modal from '../../shared/modal';
import Button from '../../shared/button';
import { useUserConfigsQuery } from '../../store/chatbox/chatboxApi';
import { useSubscriptionUpdatesMutation } from '../../store/profile/profileApi';
import Error from '../../shared/error';

interface ISubscribeInfoModal {
    openModal: boolean;
    handleCloseModal: () => void;
}

const SubscribeInfoModal = ({
    openModal,
    handleCloseModal,
}: ISubscribeInfoModal) => {
    const { data: dataConfig, refetch: refetchAll } = useUserConfigsQuery();
    const [subscriptionUpdate, { isLoading }] = useSubscriptionUpdatesMutation()
    const [submitError, setSubmitError] = useState<string>();

    const onCloseModal = () => {
        handleCloseModal()
        setSubmitError(undefined)
    }

    const onClickUpdateSubscription = async (status: string) => {
        try {
            setSubmitError(undefined)
            await subscriptionUpdate(status).unwrap();
            refetchAll()
            onCloseModal()
        } catch (err: any) {
            setSubmitError(`${err?.data?.message || err}`)
        }
    }

    const trialLeft = (startISO: string) => {
        const end = new Date(new Date(startISO).getTime() + 7 * 24 * 60 * 60 * 1000);
        const now = new Date();

        let ms = end.getTime() - now.getTime();
        if (ms <= 0) return "expired";

        const d = Math.floor(ms / 86400000);
        ms -= d * 86400000;

        const h = Math.floor(ms / 3600000);
        ms -= h * 3600000;

        const m = Math.floor(ms / 60000);

        if (d > 0) {
            const parts = [`${d} day${d > 1 ? "s" : ""}`];
            if (h > 0) parts.push(`${h}h`);
            return `${parts.join(" ")} left`;
        }

        if (h > 0) {
            const parts = [`${h}h`];
            if (m > 0) parts.push(`${m}m`);
            return `${parts.join(" ")} left`;
        }

        return `${m}m left`;
    };

    return (
        <Modal
            open={openModal}
            title='More info'
            headerStyle='border-b-1 py-3 mb-4'
            titleStyle='font-bold !text-lg !text-black dark:!text-white'
            onClose={onCloseModal}
            contentContainerStyle='!rounded-xl min-w-[95%] md:min-w-[70%] lg:min-w-[60%]'>
            <div className='p-2 max-w-[95vw] md:min-w-[70%] lg:min-w-[60%]'>
                <div className='grid grid-cols-1 lg:grid-cols-6 gap-4'>
                    <div className='lg:col-span-2 relative flex flex-row justify-center'>
                        <div className='absolute top-2 left-2 bg-[#10B981] px-3 py-2 rounded-full'>
                            <p className='text-white'>Free Trial</p>
                        </div>
                        <img src={'/leo-agent-square.svg'} className='object-contain h-auto lg:h-[100%]' />
                    </div>
                    <div className='lg:col-span-4 min-h-[100%] flex flex-col justify-between'>
                        <div>
                            <p className='dark:text-primary-dark text-3xl mb-3'>You’re currently in the <span className='font-bold'>Claire</span></p>
                            <p className='dark:text-primary-dark text-primary-default mb-10'><span className='font-bold'>{trialLeft(dataConfig?.data?.trialStarted)}</span> left until trial mode ends. <span className='font-bold'>{dataConfig?.data?.runsCount} </span>{dataConfig?.data?.runsCount === 1 ? 'run' : 'runs'} completed.</p>
                        </div>
                        <p className='my-3 dark:text-primary-dark'>Once the trial is finished you will be charged for  the monthly amount of £{dataConfig?.data?.monthValue} and you will be able to access all features included in your plan. You can cancel this anytime. If you need any help for any inquiries you have, feel free to contact us at hello@hotelworld.ai.</p>
                        {submitError && <Error text={`${submitError}`} />}
                        <div className='flex flex-col justify-center md:flex-row md:justify-end md:items-stretch'>
                            <Button
                                label='Understood'
                                onClickButton={onCloseModal}
                                className='btn-primary-rounded-less !bg-[#f5f5f5] !text-black !py-3 mb-2 mr-0 md:mr-4 md:mb-0 !shadow-none min-w-[35%]'
                            />
                            <Button
                                label={'Subscribe'}
                                className={`btn-primary-rounded-less !py-3 !shadow-none min-w-[35%] ${isLoading ? '!cursor-not-allowed opacity-60' : ''}`}
                                onClickButton={() => !isLoading && onClickUpdateSubscription('active')}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default SubscribeInfoModal;